<template>
    <div style="width:100%; height:100vh; overflow:auto;">
        <embed
            v-if="pdfSrc !== null"
            :src="pdfSrc"
            type="application/pdf"
            style="width: 100%; height: 100vh;"
        />

    </div>
</template>

<script>
import axios from 'axios';


export default {
    name: 'test',
    data: function()
    {
        return {
            pdfSrc: null
        }
    },
    mounted: function()
    {
        axios.get('https://d3mz0r05sqimo9.cloudfront.net/year_end_tax_settlement/2025_3763.pdf', {
            responseType: "blob"
        }).then(res => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            this.pdfSrc = URL.createObjectURL(blob);
        });
    }
}
</script>

<style scoped>
    .iframe {
        width: 500px;
        height: 100vh;
    }
</style>


// WEBPACK FOOTER //
// src/page/Test.vue